import * as React from 'react';

const Receipt24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16.25 7.25h-8.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.5c.41 0 .75.34.75.75s-.34.75-.75.75m-8.5 4h8.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-8.5c-.41 0-.75.34-.75.75s.34.75.75.75m0 4h2.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.5c-.41 0-.75.34-.75.75s.34.75.75.75"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M19.9 21.92c.488.222 1.1-.099 1.1-.67V4.75C21 3.23 19.77 2 18.25 2H5.75C4.23 2 3 3.23 3 4.75v16.5c0 .542.604.923 1.09.67l3.66-1.83 3.922 1.83c.21.11.46.11.67 0l3.66-1.83zM8.08 18.58a.8.8 0 0 0-.68 0l-2.91 1.46V4.75c0-.69.56-1.25 1.25-1.25h12.49c.69 0 1.25.56 1.25 1.25v15.29l-3.148-1.46a.72.72 0 0 0-.67 0l-3.66 1.83z"
  }
));
Receipt24.Size = 24;
Receipt24.Title = "Receipt";

export { Receipt24 as default };
